module.exports = __webpack_public_path__ + "static/img/bg.8e76f11.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/bg.svg
// module id = Z022
// module chunks = 0